var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_11787",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2258 5.94297C30.7293 4.78 30.0134 3.72613 29.1181 2.84035C28.2222 1.95193 27.1659 1.24591 26.0067 0.760694C24.8046 0.255555 23.5153 -0.0030044 22.2137 2.63381e-05C20.3875 2.63381e-05 18.6058 0.505889 17.0575 1.46141C16.6871 1.68998 16.3352 1.94104 16.0018 2.21458C15.6685 1.94104 15.3166 1.68998 14.9462 1.46141C13.3978 0.505889 11.6161 2.63381e-05 9.79001 2.63381e-05C8.47504 2.63381e-05 7.20082 0.254831 5.99698 0.760694C4.83389 1.24782 3.78562 1.94853 2.88552 2.84035C1.9891 3.72513 1.27303 4.77925 0.777867 5.94297C0.262993 7.1533 0 8.43856 0 9.7613C0 11.0091 0.251881 12.3093 0.751938 13.6321C1.1705 14.7375 1.77057 15.8841 2.53733 17.042C3.75228 18.8743 5.42284 20.7854 7.49715 22.7226C10.9346 25.9339 14.3387 28.1522 14.4831 28.2421L15.361 28.8117C15.75 29.0628 16.25 29.0628 16.6389 28.8117L17.5168 28.2421C17.6613 28.1485 21.0617 25.9339 24.5028 22.7226C26.5771 20.7854 28.2477 18.8743 29.4626 17.042C30.2294 15.8841 30.8332 14.7375 31.248 13.6321C31.7481 12.3093 32 11.0091 32 9.7613C32.0037 8.43856 31.7407 7.1533 31.2258 5.94297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_11787)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.0022,
    cy: 13.7517,
    r: 20.2106,
    fill: "#646874"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.07446,
    y: 20.6465,
    width: 23.6323,
    height: 8.3561,
    fill: "#C75454"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.517e6cb4045fb92b5a7cff88e03b67db.svg";
export { ForwardRef as ReactComponent };